import { render, staticRenderFns } from "./PricingTabButtonsLocator.vue?vue&type=template&id=3815ceee&scoped=true"
import script from "./PricingTabButtonsLocator.vue?vue&type=script&lang=js"
export * from "./PricingTabButtonsLocator.vue?vue&type=script&lang=js"
import style0 from "./PricingTabButtonsLocator.vue?vue&type=style&index=0&id=3815ceee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3815ceee",
  null
  
)

export default component.exports